import moment from 'moment';

import { DATE_FORMAT_FOR_UI } from 'Common/Constants';
import {
  GenericEnum,
  OrderTransactionTypesEnum,
  PrintItemActiveStatusEnum,
  PrintGroupByTypeEnum,
} from 'Common/Constants/Enumeration/CommonEnum';
import { TransactionHistoryReportEnum } from 'Common/FieldEnum';

export const BASE_URL = '/transactionhistoryreport';

const DATE = moment();

export const INITIAL_VALUES = {
  TypeId: [
    OrderTransactionTypesEnum.Adjustment,
    OrderTransactionTypesEnum.Order,
    OrderTransactionTypesEnum.Physical,
    OrderTransactionTypesEnum.Receipt,
    OrderTransactionTypesEnum.Transfer,
    OrderTransactionTypesEnum.Usage,
  ],
  ItemId: GenericEnum.InitialFilterValue,
  SortBy: GenericEnum.InitialFilterValue,
  ItemStatus: GenericEnum.InitialFilterValue,
  BidGroupId: GenericEnum.InitialFilterValue,
  ItemGroupId: GenericEnum.InitialFilterValue,
  AccountCategoryId: GenericEnum.InitialFilterValue,
  VendorId: GenericEnum.InitialFilterValue,
  DateFrom: DATE.subtract(1, 'month').format(DATE_FORMAT_FOR_UI),
  DateTo: DATE.add(2, 'month').format(DATE_FORMAT_FOR_UI),
  [TransactionHistoryReportEnum.ItemStatus]: PrintItemActiveStatusEnum.Active,
};

export const ItemCodeDescriptionChangeEnum = {
  ItemDescriptionFirst: 0,
  ItemCodeFirst: 1,
};

export const printOptions = [
  { value: PrintGroupByTypeEnum.Item, label: 'Item' },
  { value: PrintGroupByTypeEnum.Site, label: 'Site' },
];

export const itemSortOption = [
  {
    value: ItemCodeDescriptionChangeEnum.ItemDescriptionFirst,
    label: 'Item Description, Code',
  },
  {
    value: ItemCodeDescriptionChangeEnum.ItemCodeFirst,
    label: 'Item Code, Description',
  },
];

export const activeStatusOptions = [
  {
    key: 0,
    value: PrintItemActiveStatusEnum.Active,
    text: 'Active',
  },
  {
    key: 1,
    value: PrintItemActiveStatusEnum.Inactive,
    text: 'Inactive',
  },
];

export const PRINT_API_URL = 'TransactionHistoryReports/GetTxnHistoryPrint';



// WEBPACK FOOTER //
// ./src/pages/reports/inventory/transactionhistoryreport/helper/index.js